var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m437 391c-8.284 0-15 6.716-15 15v30c0 8.284 6.716 15 15 15s15-6.716 15-15v-30c0-8.284-6.716-15-15-15z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 437,
    cy: 136,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 437,
    cy: 346,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "m497 1h-202c-8.284 0-15 6.716-15 15v105h-235c-24.813 0-45 20.187-45 45v220c0 24.813 20.187 45 45 45h96v.279c0 20.748-10.944 39.503-28.771 49.721h-16.229c-8.284 0-15 6.716-15 15s6.716 15 15 15h401c8.284 0 15-6.716 15-15v-480c0-8.284-6.716-15-15-15zm-15 30v30h-172v-30zm-172 60h172v120h-90v-45c0-24.813-20.187-45-45-45h-37zm82 150h90v30h-90zm-347-90h302c8.271 0 15 6.729 15 15v175h-332v-175c0-8.271 6.729-15 15-15zm-15 235v-15h332v15c0 8.271-6.729 15-15 15h-302c-8.271 0-15-6.729-15-15zm250 95h-.229c-17.827-10.219-28.771-28.973-28.771-49.721v-.279h29zm-109-49.721v-.279h50v.279c0 18.217 5.538 35.429 15.429 49.721h-80.858c9.891-14.292 15.429-31.504 15.429-49.721zm139 49.721v-50h37c24.813 0 45-20.187 45-45v-85h90v180z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.ad37a288.svg";
export { ForwardRef as ReactComponent };